import { AnyAction } from 'redux';

import slice from '../reducer/slice';
import { IStation } from 'dataSources/Typicode/stations';

type TOperation = (stations: IStation[]) => AnyAction;

const operation: TOperation = (stations) => slice.actions.setStations(stations);

export default operation;
